import type {
  DailyMetricResult,
  DateRange,
  HealthDataReader,
  HealthScope,
  PermissionResult,
} from './HealthDataReader';

const EMPTY: DailyMetricResult = { metrics: [], sampleCount: 0 };

/** Android Health Connect stub — real implementation lands in a later phase. */
export class HealthConnectReader implements HealthDataReader {
  readonly platform = 'healthconnect' as const;
  isAvailable(): boolean { return false; }
  async requestPermissions(_scopes: HealthScope[]): Promise<PermissionResult> { return { granted: [] }; }
  async getSleep(_r: DateRange): Promise<DailyMetricResult> { return EMPTY; }
  async getRestingHR(_r: DateRange): Promise<DailyMetricResult> { return EMPTY; }
  async getHRV(_r: DateRange): Promise<DailyMetricResult> { return EMPTY; }
  async getSteps(_r: DateRange): Promise<DailyMetricResult> { return EMPTY; }
  async getActiveEnergy(_r: DateRange): Promise<DailyMetricResult> { return EMPTY; }
  async getVO2Max(_r: DateRange): Promise<DailyMetricResult> { return EMPTY; }
}
